/* tslint:disable */
/* eslint-disable */
/**
 * Datixo API
 * API endpoints for communication with Datixo.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: api@datixo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { OrderDomainCentrePairData } from './OrderDomainCentrePairData';
import {
    OrderDomainCentrePairDataFromJSON,
    OrderDomainCentrePairDataFromJSONTyped,
    OrderDomainCentrePairDataToJSON,
    OrderDomainCentrePairDataToJSONTyped,
} from './OrderDomainCentrePairData';

/**
 * 
 * @export
 * @interface OrderDomainCentreAuditData
 */
export interface OrderDomainCentreAuditData {
    /**
     * 
     * @type {number}
     * @memberof OrderDomainCentreAuditData
     */
    totalOrders?: number;
    /**
     * 
     * @type {number}
     * @memberof OrderDomainCentreAuditData
     */
    ordersWithoutDomain?: number;
    /**
     * 
     * @type {number}
     * @memberof OrderDomainCentreAuditData
     */
    ordersOnDisabledDomains?: number;
    /**
     * 
     * @type {Array<OrderDomainCentrePairData>}
     * @memberof OrderDomainCentreAuditData
     */
    pairs?: Array<OrderDomainCentrePairData>;
}

/**
 * Check if a given object implements the OrderDomainCentreAuditData interface.
 */
export function instanceOfOrderDomainCentreAuditData(value: object): value is OrderDomainCentreAuditData {
    return true;
}

export function OrderDomainCentreAuditDataFromJSON(json: any): OrderDomainCentreAuditData {
    return OrderDomainCentreAuditDataFromJSONTyped(json, false);
}

export function OrderDomainCentreAuditDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): OrderDomainCentreAuditData {
    if (json == null) {
        return json;
    }
    return {
        
        'totalOrders': json['totalOrders'] == null ? undefined : json['totalOrders'],
        'ordersWithoutDomain': json['ordersWithoutDomain'] == null ? undefined : json['ordersWithoutDomain'],
        'ordersOnDisabledDomains': json['ordersOnDisabledDomains'] == null ? undefined : json['ordersOnDisabledDomains'],
        'pairs': json['pairs'] == null ? undefined : ((json['pairs'] as Array<any>).map(OrderDomainCentrePairDataFromJSON)),
    };
}

export function OrderDomainCentreAuditDataToJSON(json: any): OrderDomainCentreAuditData {
    return OrderDomainCentreAuditDataToJSONTyped(json, false);
}

export function OrderDomainCentreAuditDataToJSONTyped(value?: OrderDomainCentreAuditData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'totalOrders': value['totalOrders'],
        'ordersWithoutDomain': value['ordersWithoutDomain'],
        'ordersOnDisabledDomains': value['ordersOnDisabledDomains'],
        'pairs': value['pairs'] == null ? undefined : ((value['pairs'] as Array<any>).map(OrderDomainCentrePairDataToJSON)),
    };
}

